import "./WithdrawUSDTPage.scss";
import { ChooseTab } from "./components";

const WithdrawUSDTPage = () => {
  return (
    <div className="WithdrawUSDTPage">
      <ChooseTab />
    </div>
  );
};

export default WithdrawUSDTPage;
